import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import ExerciseCategoryService from "../../../services/ExerciseCategoryService";
import ExerciseLoadTypeService from "../../../services/ExerciseLoadTypeService";
import ExercisesCreateForm from "./ui/ExercisesCreateForm";
import { ExerciseCategory, ExerciseLoadType } from "../../../models";
import ExerciseSkeleton from "./skeletons/ExerciseSkeleton";

export default function ExerciseCreatePage() {
  const apiCategories = new ExerciseCategoryService();
  const apiLoadTypes = new ExerciseLoadTypeService();
  const [categories, setCategories] = useState<ExerciseCategory[]>([]);
  const [loadTypes, setLoadTypes] = useState<ExerciseLoadType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const [categoriesData, loadTypesData] = await Promise.all([
      apiCategories.getExerciseCategories(),
      apiLoadTypes.getExerciseLoadTypes(),
    ]);
    setCategories(categoriesData);
    setLoadTypes(loadTypesData);

    setLoading(false);
  };

  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Categories", href: "/admin/exercise-categories" },
          {
            label: "create",
            href: `/admin/exercise-categories/Create`,
            active: true,
          },
        ]}
      />
      {loading ? (<ExerciseSkeleton />) :
      <ExercisesCreateForm categories={categories} loadTypes={loadTypes} />}

      
    </main>
  );
}
